import UserListModel from "./models/UserListModel";

const UserListStore = {
    name: 'UserListStore',
    spec: UserListModel,
    saveLocally: false,
    initialState: {
        users: []
    },
};

const stores = [UserListStore];

export default stores;